import {
  defFetchList,
  defFetchOne,
  defCreate,
  defUpdateOne,
  defDeleteOne,
  defUpdateStatus
} from '@/api/default'
import request from '@/api/request'

const basePath = '/user/'

export function fetchList (query, platform) {
  return defFetchList(basePath + platform, query)
}

export function fetchOne (id, platform) {
  return defFetchOne(basePath + platform, id)
}

export function create (data, platform) {
  return defCreate(basePath + platform, data)
}

export function updateOne (id, data, platform) {
  return defUpdateOne(basePath + platform, id, data)
}

export function deleteOne (id, platform) {
  return defDeleteOne(basePath + platform, id)
}

export function updateStatus (id, data, platform) {
  return defUpdateStatus(basePath + platform, id, data)
}

export function fetchAttendanceHistory (platform, id, query) {
  return request({
    url: basePath + platform + '/' + id + '/attendance-history',
    method: 'get',
    params: query
  })
}

export function fetchAttendanceHistoryScore (platform, id) {
  return request({
    url: basePath + platform + '/' + id + '/attendance-history-score',
    method: 'get'
  })
}

export function revokeMetabaseToken (id) {
  return request({
    url: basePath + 'admin/' + id + '/metabase_token',
    method: 'put'
  })
}
